
import { Input, Checkbox, Drawer } from "element-ui"
import drawerHeader from "../drawer/components/drawerHeader.vue"
import editRecipient from "../drawer/editRecipient.vue"
import { getConsignInfo } from "@/api/cart"
import { getCurrentAddress } from "@/utils/utils"

export default {
  components: {
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Drawer.name]: Drawer,
    editRecipient,
    drawerHeader
  },
  props: {
    shipmentType: {
      type: Number,
      default: 0
    },
    info: {
      type: Object,
      default: () => {}
    },
    checkoutParams: {
      type: Object,
      default: () => {}
    },
    isPickup: {
      type: Boolean,
      default: false
    },
    storeInfo: {
      type: Object,
      default: () => {}
    },
    offlinePaymentFlag: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      name: "",
      code: "",
      num: "",
      email: "",
      baseInfo: {},
      phoneIsEdit: false,
      insIsEdit: false,
      instruction: {
        addDef1: false,
        addDef2: false,
        content: ""
      },
      insStr: ""
    }
  },
  computed: {
    recipientInfo() {
      return {
        name: this.name || "",
        num: this.num || "",
        code: this.code || "",
        email: this.email || ""
      }
    }
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.name = localStorage.getItem("checkout_name") || newVal.consignee || ""
          const mobilPhone = localStorage.getItem("checkout_phone") || newVal.mobilPhone || ""
          if (mobilPhone && mobilPhone.includes(" ")) {
            this.code = mobilPhone.split(" ")[0]
            this.num = mobilPhone.split(" ")[1]
            // +
            if (!this.code.includes("+")) {
              this.code = "+" + this.code
            }
          } else {
            this.num = mobilPhone
          }
          this.baseInfo = newVal
          this.email = newVal.email
        }
      },
      immediate: true
    }
  },
  methods: {
    async handleCheckout({ name, num, code }) {
      const addrItem = getCurrentAddress()
      try {
        const params = {
          phone: `${code} ${num}`,
          userName: encodeURIComponent(name),
          consignee: encodeURIComponent(name),
          type: addrItem.type,
          id: this.baseInfo.id,
          address2: encodeURIComponent(this.baseInfo.addressName),
          unitFloor: encodeURIComponent(this.baseInfo.addressDetail),
          lng: this.baseInfo.longitude,
          lat: this.baseInfo.latitude,
          label: encodeURIComponent(addrItem.label),
          priority: addrItem.priority
        }
        const res = await getConsignInfo({ param: JSON.stringify(params) })

        this.$navigation.replace({
          path: "/checkout",
          query: {
            params: JSON.stringify({
              ...this.checkoutParams,
              addressId: (res && res.id) || ""
            })
          }
        })
        this.$emit("changed")
      } catch (error) {
        console.log(error)
      }
    },
    onRecipientClose() {
      this.phoneIsEdit = false
    },
    onRecipientSave(val) {
      if (!val.name) {
        this.$message({
          message: this.$t("address.pleaseEnterName"),
          type: "warning"
        })
      } else if (!val.code || !val.num) {
        this.$message({
          message: this.$t("address.pleaseEnterPhoneNumber"),
          type: "warning"
        })
      } else {
        this.phoneIsEdit = false
        if (this.isPickup) {
          this.name = val.name
          localStorage.setItem("checkout_name", val.name)
          this.code = val.code
          this.num = val.num
          this.baseInfo.email = val.email
          this.email = val.email
          localStorage.setItem("checkout_phone", val.code + " " + val.num)
          this.$emit("pickupChanged", val)
        } else {
          this.handleCheckout(val)
        }
      }
    },
    handleSaveIns() {
      let str = ""
      if (this.instruction.addDef1) {
        str += this.$t("checkout.mark1") + ";\n"
      }
      if (this.instruction.addDef2) {
        str += this.$t("checkout.mark2") + ";\n"
      }
      str += this.instruction.content + "\n"
      this.insStr = str
      this.insIsEdit = false
      this.$emit("ins-changed", this.insStr)
    },
    getDisplayStore() {
      const curSelStore = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : {}
      return curSelStore
    }
  }
}
